import React from 'react';
import PropTypes from 'prop-types';
import { Chip, withStyles } from '@material-ui/core';
import styles from './score-badge.style';
import {
  formatSuggestionScore,
  getSuggestionScoreTier,
} from '../../utils/lms-course-review.utils';
import { SCORE_TIER_LABELS } from '../../constants/score-tiers.constants';

const ScoreBadge = ({ classes, score, size, showLabel }) => {
  const tier = getSuggestionScoreTier(score);
  if (tier === 'none') return null;

  const label = showLabel
    ? `${SCORE_TIER_LABELS[tier]} · ${formatSuggestionScore(score)}`
    : formatSuggestionScore(score);

  return (
    <Chip
      size={size}
      label={label}
      className={classes[tier]}
      data-testid={`score-badge-${tier}`}
    />
  );
};

ScoreBadge.propTypes = {
  score: PropTypes.number,
  size: PropTypes.string,
  showLabel: PropTypes.bool,
};

ScoreBadge.defaultProps = {
  score: null,
  size: 'small',
  showLabel: false,
};

export default withStyles(styles)(ScoreBadge);
